<template>
  <div
    v-if="supplier && !!supplier.hbt_flow_enabled"
    class="wrap-hbt-booking-sidebar"
  >
    <booking-invoice
      :supplierName="supplier.name"
      :dates="bookingDates"
      :roomsFilter="bookingRooms"
      :location="supplier.country.name || supplier.destination.name"
    >
      <template v-slot:button>
        <button
          v-if="showSelectRoomMobile"
          @click="onSelectGroup()"
          class="flex items-center btn btn-primary btn-outlined justify-center w-full mt-10"
        >
          Select room {{ unselectedGroups.join(" & ") }}
        </button>
        <button
          v-else
          @click="continueToReserve"
          class="flex items-center btn btn-primary justify-center w-full mdsm:mt-10"
        >
          <span class="lg:hidden"> Continue to reserve </span>
          <span class="mdsm:hidden"> Continue to reserve </span>
        </button>
      </template>

      <template v-slot:warning>
        <div v-if="!hiddenError && showError" class="booking-error">
          <svg fill="#e12f22" width="48" height="24">
            <use xlink:href="/img/sprite.svg#ic_info"></use>
          </svg>
          <span class="ml-2">
            You have selected fewer rooms than you requested. Please make a
            selection for all rooms
          </span>
        </div>
      </template>
    </booking-invoice>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CurrencyContext from "../../core/CurrencyContext";
import BookingInvoice from "./BookingInvoice";
import { tryParse } from "../../../helpers";

export default {
  components: {
    CurrencyContext,
    BookingInvoice,
  },
  props: ["review", "images"],
  data() {
    return {
      supplier: null,
      showError: false,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;
    });
  },
  computed: {
    ...mapState([
      "bookingDates",
      "selectedRooms",
      "bookingRooms",
      "groupsResult",
    ]),
    ...mapGetters(["applyRoomMarkup", "getAllState", "getSelectedRoomDetails"]),
    showSelectRoomMobile() {
      const isTablet = window.matchMedia(
        "(min-width: 601px) and (max-width: 1200px)"
      ).matches;
      const isMobile = window.matchMedia("(max-width: 600px)").matches;
      return (
        (isMobile || isTablet) &&
        this.getSelectedRoomDetails.length < this.bookingRooms.length
      );
    },
    hiddenError() {
      return (
        this.showError &&
        this.bookingRooms.length === this.getSelectedRoomDetails.length
      );
    },
    unselectedGroups() {
      const selectedGroups = this.getSelectedRoomDetails.map((room) =>
        room.group.slice(5)
      );

      let results = [];
      for (let i = 1; i <= this.bookingRooms.length; i++) {
        if (!selectedGroups.includes(i.toString())) {
          results.push(i);
        }
      }
      return results;
    },
  },
  methods: {
    onSelectGroup() {
      if (this.unselectedGroups[0]) {
        this.$store.commit(
          "setSelectedGroupId",
          `group-${this.unselectedGroups[0]}`
        );
      }
      this.$emit("modal-close");

      this.$nextTick(() => {
        window.scrollToElement($(".hbt-booking-form"));
      });
    },
    continueToReserve() {
      if (this.bookingRooms.length > this.getSelectedRoomDetails.length) {
        this.showError = true;
      } else {
        this.showError = false;
        const getSelectedRoomDetails = this.getSelectedRoomDetails.map(
          (room) => {
            room.price = this.applyRoomMarkup(room.code, room.price);
            return room;
          }
        );

        const data = {
          dates: [
            moment(this.bookingDates[0]).format("YYYY-MM-DD"),
            moment(
              this.bookingDates[1] ? this.bookingDates[1] : this.bookingDates[0]
            ).format("YYYY-MM-DD"),
          ],
          getSelectedRoomDetails,
          ...this.getAllState,
        };

        localStorage.setItem("hbtResortData", JSON.stringify(data));
        window.location.href = "/booking";
      }
    },
  },
};
</script>
